import { EmoMega, Plus } from "@assets"
import { Head } from "@inertiajs/react"

import FeedItem, {
  type FeedItem as FeedItemType,
} from "@/components/feed/feed-item"
import { Button } from "@/components/ui/button"
import AppLayout from "@/layouts/app-layout"

interface Image {
  id: number | string
  url: string
}

interface Video {
  id: number | string
  url: string
}

interface Announcement {
  id: number | string
  content: string
  created_at: string
  author?: {
    id: number
    name: string
    avatar_url?: string
    verified?: boolean
  }
  images?: Image[]
  video_url?: string | null
  videos?: Video[]
  cover_url?: string | null
  shares_count?: number
  is_favorited?: boolean
  favorites_count?: number
}

interface Props {
  announcements: Announcement[]
  can_create?: boolean
}

export default function AnnouncementsIndex({
  announcements,
  can_create,
}: Props) {
  const normalizedAnnouncements: FeedItemType[] = (announcements ?? []).map(
    (announcement) => {
      const sourceId =
        typeof announcement.id === "number"
          ? announcement.id
          : Number.parseInt(String(announcement.id), 10) || 0

      return {
        id: `announcement-${announcement.id}`,
        source_id: sourceId,
        type: "announcement",
        created_at: announcement.created_at,
        content: announcement.content,
        author: announcement.author,
        cover_url:
          announcement.cover_url ?? announcement.images?.[0]?.url ?? null,
        video_url: announcement.video_url ?? null,
        images: announcement.images,
        videos: announcement.videos,
        is_favorited: announcement.is_favorited,
        favorites_count: announcement.favorites_count,
      } as FeedItemType
    },
  )

  return (
    <AppLayout>
      <Head title="Anuncios" />
      <div className="bg-background min-h-screen">
        <div className="mx-auto max-w-6xl space-y-3 md:p-6">
          <div className="flex flex-col">
            <div className="flex items-center justify-center gap-4">
              <h1 className="text-foreground flex items-center gap-2 text-[21px] font-bold tracking-[0.21px] md:text-3xl">
                <span className="bg-card flex h-[42px] w-[42px] flex-shrink-0 items-center justify-center rounded-full p-1">
                  <img
                    src={EmoMega}
                    alt="Pin"
                    className="h-full w-full object-contain"
                  />
                </span>
                Anuncios
              </h1>
              {can_create && (
                <a href="/anuncios/new">
                  <Button
                    variant="default"
                    className="flex flex-shrink-0 items-center gap-2"
                  >
                    <Plus className="h-4 w-4" />
                    <span className="hidden sm:inline">Crear anuncio</span>
                  </Button>
                </a>
              )}
            </div>
          </div>

          <div className="space-y-4 pb-24">
            {normalizedAnnouncements.length ? (
              normalizedAnnouncements.map((item) => (
                <FeedItem key={item.id} item={item} />
              ))
            ) : (
              <div className="border-muted-foreground/30 text-muted-foreground bg-card rounded-2xl border border-dashed px-6 py-10 text-center">
                No hay anuncios disponibles por ahora.
              </div>
            )}
          </div>
        </div>
      </div>
    </AppLayout>
  )
}
